<ng-container>
  <div class="spacing--margin-all">
    <agr-summary-card
      [title]="'settings.navigation.sustainability' | translate"
      [canExpand]="false"
    >
      <tr class="spacing--padding-all spacing--margin-left">
        <td>{{ 'sustainability.farm-settings-enable-co2-calculation' | translate }}</td>
        <td>
          <mat-slide-toggle
            [hideIcon]="true"
            class="spacing--padding-vertical spacing--padding-left"
            color="primary"
            data-test="sustainability-settings-overview_toggle"
            [checked]="enableCO2Calculation"
            (change)="onToggleCO2Calculation(!enableCO2Calculation)"
          >
          </mat-slide-toggle>
        </td>
      </tr>
    </agr-summary-card>
  </div>
</ng-container>
